import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Audio Variants configuration',
  attributeName: 'vodAudioVariant',
  validationUrl:'vod',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'audioVariant',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'text or number',
      label: 'Audio variant',
      required: true,
      helpText: 'Chosoe the http audio variant, it has the value 0:a:0 or the format es-ES',
      errorText: '',
    },
    {
      attributeName: 'audioLanguage',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Laguage available for this vod audio.',
      label: 'Language',
      pattern: /^[A-Za-z-]+$/,
      required: true,
      errorText: '',
    },
    {
      attributeName: 'audioChannel',
      type: FormInputTypes.SELECT,
      helpText: 'The audio channel to apply in all the job.',
      label: 'Audio Channel',
      required: true,
      default: '2',
      options: [
        { name: '2', value: '2' },
        { name: '5.1', value: '5.1' },
        { name: '7.1', value: '7.1' },
      ],
    },
  ]
};
